import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from '../common/media_query';
import ProductDetailsVerticalScrollImages from './product_details/vertical_scroll_images';
import ProductDetailsHorizontalScrollImages from './product_details/horizontal_scroll_images';
import ProductDetailsNavigation from './product_details/navigation';
import ProductDetailsReviews from './product_details/reviews';

const CONTAINER_ID = 'product-details-container';

export default function ProductDetails(props) {
  const { reviews = [] } = props.product;
  const { page_type } = props.analytics;

  return (
    <div className="product-details-wrapper">
      <ProductDetailsNavigation
        shoppingNavigation={props.shoppingNavigation}
      />
      <div id={CONTAINER_ID}>
        <MediaQuery breakpoint="desktop">
          <ProductDetailsVerticalScrollImages {...props} parentElementID={CONTAINER_ID} />
        </MediaQuery>
        <MediaQuery breakpoint="notDesktop">
          <ProductDetailsHorizontalScrollImages {...props} />
        </MediaQuery>
      </div>
      {
        reviews && reviews.length > 0 &&
        <ProductDetailsReviews reviews={reviews} page_type={page_type} />
      }
    </div>
  );
}

ProductDetails.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    brand: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    }),
    name: PropTypes.string.isRequired,
    product_url: PropTypes.string.isRequired,
    offer: PropTypes.shape({
      currency: PropTypes.string,
      price: PropTypes.number,
      sale_price: PropTypes.number,
      retailer: PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string
      })
    }),
    images: PropTypes.array,
    description: PropTypes.string.isRequired,
    is_sponsored: PropTypes.bool,
    click_tracker: PropTypes.string,
    impression_tracker: PropTypes.string,
    entries: PropTypes.arrayOf(PropTypes.shape({
      truncated_short_title_80: PropTypes.string,
      url: PropTypes.string,
      label: PropTypes.string
    }))
  }),
  meta_data: PropTypes.shape({
    meta_title: PropTypes.string,
    meta_description: PropTypes.string
  }),
  analytics: PropTypes.shape({
    url_full: PropTypes.string
  }),
  shoppingNavigation: PropTypes.shape({
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        path: PropTypes.string
      })
    )
  })
};
